import React, { useContext, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ActionModal, Button } from '@livechat/design-system'
import firebase from '../firebase'
import { AuthContext } from '../contexts/auth'

const buttonCss = css`
  width: 140px;
  margin: 0 4px;
`

const DeleteNotificationModal = ({ onClose, notification, onDelete }) => {
  const auth = useContext(AuthContext)
  const [isDeleting, setIsDeleting] = useState(false)

  const deleteNotification = async () => {
    setIsDeleting(true)

    try {
      let firebaseApp

      switch (auth.appName) {
        case 'slack3':
          firebaseApp = firebase.slack3
          break

        case 'slack2':
          firebaseApp = firebase.slack2
          break

        default:
          firebaseApp = firebase.slack
      }

      const db = firebaseApp.firestore()
      const licensesRef = db
        .collection('licenses')
        .doc(`${auth.agentData.license}`)
      const doc = await licensesRef.get()
      const currentNotifications = doc.exists ? doc.data().notifications : []
      let newNotifications = []

      if (notification) {
        newNotifications = currentNotifications.filter(currentNotification => {
          return currentNotification.id !== notification.id
        })
      }

      await db
        .collection('licenses')
        .doc(`${auth.agentData.license}`)
        .update({
          notifications: newNotifications,
          updated_at: new Date().toISOString(),
        })

      setIsDeleting(false)
      onClose()
      onDelete()
    } catch (err) {
      setIsDeleting(false)
      console.error(err)
    }
  }
  return (
    <div
      css={css`
        .lc-action-modal__heading {
          font-size: 16px;
          margin-bottom: 0;
          margin-top: 10px;
        }
      `}
    >
      <ActionModal
        onClose={onClose}
        heading="Are you sure you want to remove this notification?"
        actions={
          <React.Fragment>
            <Button size="compact" onClick={onClose} secondary css={buttonCss}>
              Cancel
            </Button>

            <Button
              size="compact"
              onClick={deleteNotification}
              destructive
              css={buttonCss}
              loading={isDeleting}
            >
              Delete
            </Button>
          </React.Fragment>
        }
        icon=""
      ></ActionModal>
    </div>
  )
}

export default DeleteNotificationModal
